import { Avatar, Group, Text } from "@mantine/core";

/** Customer identity cell: an initials avatar (auto-colored from the name) next
 *  to the customer name. Keeps the column readable and professional. */
export function CustomerCell({ name }: { name: string }) {
  return (
    <Group gap="xs" wrap="nowrap">
      <Avatar name={name} color="initials" size={28} radius="xl" />
      <Text size="sm" lineClamp={1}>{name}</Text>
    </Group>
  );
}
